import React, { useState, useEffect, useReducer } from "react";
import MUIDataTable from "mui-datatables";
import moment from "moment";
import {
  Grid,
  Button,
  List,
  Box,
  TextField,
  SwipeableDrawer,
  FormControl,
  InputLabel,
  Typography,
  TablePagination,
  Switch,
  Backdrop,
  CircularProgress,
  withStyles,
  DialogTitle,
  Dialog,
  DialogContent,
} from "@material-ui/core";
import PageTitle from "../../../components/PageTitle";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardMedia";
import CardActions from "@material-ui/core/CardActions";
import { toast } from "react-toastify";
import ViewIcon from "@material-ui/icons/Visibility";
import CloseIcon from "@material-ui/icons/Close";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import Notification from "../../../components/Notification";
import EditIcon from "@material-ui/icons/Edit";
import Tooltip from "@material-ui/core/Tooltip";
import useStyles from "../../../themes/style.js";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { HiQuestionMarkCircle } from "react-icons/hi2";
const positions = [toast.POSITION.TOP_RIGHT];

const InformationTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#c8d8f8",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 250,
    fontFamily: "'Inter', sansSerif",
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #7da5f6",
  },
  arrow: {
    color: "#7da5f6",
  },
}))(Tooltip);

export default function LOPDetails() {
  const classes = useStyles();

  const token = localStorage.getItem("token");

  const [count, setCount] = useState(0);

  const [loader, setLoader] = useState(false);
  const mobileQuery = useMediaQuery("(max-width:600px)");
  const [lopDetailsData, setLopDetailsData] = useState([]);
  const [lopID, setLopID] = useState("");
  const [jobPostingView, setJobpostingView] = useState({});

  const [page, setPage] = useState(0);
  const [currerntPage, setCurrerntPage] = useState(1);
  const [confimationOpen, setConfimationOpen] = useState(false);
  const [employeeLOPTableOpen, setEmployeeLOPTableOpen] = useState(false);

  const handleLOPTableModalOpen = (item) => {
    setJobpostingView(item);
    setEmployeeLOPTableOpen(true);
  };

  const handleLOPTableModalClose = () => {
    setEmployeeLOPTableOpen(false);
  };

  const handleConfirmationModalOpen = (id) => {
    setLopID(id);
    setConfimationOpen(true);
  };

  const handleConfirmationModalClose = () => {
    setConfimationOpen(false);
    setLopID("");
  };

  const HeaderElements = () => <>Total : {count}</>;

  var [errorToastId, setErrorToastId] = useState(null);

  function sendNotification(componentProps, options) {
    return toast(
      <Notification
        {...componentProps}
        className={classes.notificationComponent}
      />,
      options,
    );
  }
  function handleNotificationCall(notificationType, message) {
    var componentProps;

    if (errorToastId && notificationType === "error") return;

    switch (notificationType) {
      case "info":
        componentProps = {
          type: "feedback",
          message: message,
          variant: "contained",
          color: "primary",
        };
        break;
      case "error":
        componentProps = {
          type: "message",
          message: message,
          variant: "contained",
          color: "secondary",
        };
        break;
      default:
        componentProps = {
          type: "shipped",
          message: message,
          variant: "contained",
          color: "success",
        };
    }

    var toastId = sendNotification(componentProps, {
      type: notificationType,
      position: positions[2],
      progressClassName: classes.progress,
      onClose: notificationType === "error" && (() => setErrorToastId(null)),
      className: classes.notification,
      autoClose: notificationType === "error" ? false : 5000,
    });

    if (notificationType === "error") setErrorToastId(toastId);
  }

  function getEmpName(user) {
    let empName;
    if (user.employee) {
      empName = user.employee.firstName + " " + user.employee.lastName;
    }

    if (user.recruiter) {
      empName = user.recruiter.firstName + " " + user.recruiter.lastName;
    }
    return empName;
  }

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .required("Source Name is required")
      .matches(/^[^!@#$%^&*+=<>:;|~]*$/, {
        message: "Source Name be Alphanumeric",
      }),
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    fetchData();
  }, [token]);

  const fetchData = async () => {
    setLoader(true);

    axios({
      method: "get",
      url: `${process.env.REACT_APP_SERVER}leave/viewAllLop?page=${currerntPage}`,

      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        setLoader(false);

        setLopDetailsData(response.data.data);
        setCount(response.data.count);
      }
    });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setCurrerntPage(newPage + 1);
    setLoader(true);

    axios({
      method: "get",
      url: `${process.env.REACT_APP_SERVER}leave/viewAllLop?page=${page}`,

      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        setLopDetailsData(response.data.data);
        setCount(response.data.count);
        setLoader(false);
      }

      setLoader(false);
    });
  };

  function handleDeleteLop() {
    try {
      setLoader(true);
      axios({
        method: "post",
        url: `${process.env.REACT_APP_SERVER}leave/deleteLop`,
        data: { id: lopID },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).then(function (response) {
        setLoader(false);
        if (response.data.status === true) {
          handleNotificationCall("success", response.data.message);

          const updatedList = jobPostingView.lops.filter(
            (item) => item.id !== lopID,
          );

          setJobpostingView({ ...jobPostingView, lops: updatedList });

          fetchData();
          handleConfirmationModalClose();
        } else {
          handleNotificationCall("error", response.data.message);
        }
      });
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  }

  const lopDetails = (item) => {
    const lossOfPayData = item.lops;
    return (
      <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
        <p>{lossOfPayData.reduce((sum, item) => sum + item.value, 0)} Days</p>
        <div>
          <InformationTooltip
            title={
              <React.Fragment>
                <Typography color="inherit" style={{ fontSize: "12px" }}>
                  <table
                    className="table table-striped"
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                    }}
                    border="1"
                  >
                    <thead className="table-dark">
                      <tr>
                        <th>Date</th>
                        <th className="text-end">Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      {lossOfPayData.map((item, index) => (
                        <tr key={index}>
                          <td style={{ padding: "4px" }}>
                            {moment(item.date).format("DD-MM-YYYY")}
                          </td>
                          <td align="right" style={{ padding: "4px" }}>
                            {item.value}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Typography>
              </React.Fragment>
            }
            placement="top"
            aria-label="title"
          >
            <div className={classes.infoTooltipIcon}>
              <HiQuestionMarkCircle style={{ color: "#3f3ffe",marginBottom:"12px" }} />
            </div>
          </InformationTooltip>
        </div>
      </div>
    );
  };

  return (
    <>
      <Grid container direction="row" spacing={2} className={classes.heading}>
        <Grid item xs={9} sm={7} md={8} lg={6}>
          <PageTitle title="Loss of Pay Details" />
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <MUIDataTable
            title=""
            options={{
              textLabels: {
                body: {
                  noMatch: "Oops! Matching record could not be found",
                },
              },
              pagination: false,
              sort: false,
              selectableRows: "none",
              search: false,
              filter: false,
              download: false,
              print: false,
              customToolbar: () => <HeaderElements />,
              responsive: mobileQuery === true ? "vertical" : "standard",
            }}
            columns={[
              {
                name: "S.No",
              },

              {
                name: "Employee Name",
              },

              {
                name: "LOP Day Count",
              },
              {
                name: "Actions",
              },
              {
                name: "Posted Date",
              },
            ]}
            data={lopDetailsData.map((item, index) => {
              return [
                <>
                  {currerntPage !== 0
                    ? 10 * currerntPage - 10 + index + 1
                    : index + 1}
                </>,
                getEmpName(item),
                lopDetails(item),
                <>
                  <Grid container className={classes.space}>
                    <Grid item xs className={classes.toolAlign}>
                      <Tooltip
                        title="Edit LOP Dates"
                        placement="bottom"
                        aria-label="edit"
                      >
                        <ViewIcon
                          className={classes.toolIcon}
                          onClick={() => {
                            handleLOPTableModalOpen(item);
                          }}
                        />
                      </Tooltip>
                    </Grid>
                  </Grid>
                </>,
                moment(item.createdAt).format("DD-MM-YYYY"),
              ];
            })}
          />

          <Dialog
            open={employeeLOPTableOpen}
            fullWidth
            maxWidth="xs"
            onClose={handleLOPTableModalClose}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle>Loss of Pay Date</DialogTitle>
            <DialogContent>
              <Grid container direction="row" spacing={2}>
                <table
                  className="table table-striped table-hover"
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    marginBottom: "20px",
                  }}
                  border="1"
                >
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Value</th>
                      <th className="text-end">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {jobPostingView.lops &&
                      jobPostingView.lops.map((item, index) => (
                        <tr key={index}>
                          <td style={{ padding: "4px" }}>
                            {moment(item.date).format("DD-MM-YYYY")}
                          </td>
                          <td align="left" style={{ padding: "4px" }}>
                            {item.value}
                          </td>
                          <td align="right">
                            <span
                              style={{
                                color: "red",
                                textDecoration: "underline",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                handleConfirmationModalOpen(item.id)
                              }
                            >
                              Delete
                            </span>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </Grid>
            </DialogContent>
          </Dialog>

          <Dialog
            onClose={handleConfirmationModalClose}
            aria-labelledby="dialog-title"
            open={confimationOpen}
            width="md"
            PaperProps={{
              style: {
                width: "100%",
              },
            }}
          >
            <DialogTitle className={classes.digTitle}>
              <div className={classes.center}>
                <Typography
                  variant="subtitle2"
                  className={classes.digColor + " " + classes.digCenter}
                >
                  Confirmation
                </Typography>

                <div className={classes.drawerClose}>
                  <CloseIcon
                    className={classes.digClose}
                    size="14px"
                    onClick={handleConfirmationModalClose}
                  />
                </div>
              </div>
            </DialogTitle>

            <DialogContent className={classes.chatListBackGround}>
              <Typography variant="subtitle2">
                Do you want to delete this loss of pay data?
              </Typography>
              <div className={classes.sendWhatsapp}>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={handleDeleteLop}
                >
                  Yes
                </Button>

                <Button
                  variant="contained"
                  size="small"
                  color="secondary"
                  onClick={handleConfirmationModalClose}
                >
                  No
                </Button>
              </div>
            </DialogContent>
          </Dialog>

          <Grid container spacing={2} className={classes.pagination}>
            <TablePagination
              rowsPerPageOptions={[50]}
              component="div"
              count={count}
              rowsPerPage={10}
              page={page}
              onPageChange={handleChangePage}
            />
          </Grid>
        </Grid>
      </Grid>

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}
